(function () {
  var EMBED_SRC =
    'https://embed.podcasts.apple.com/us/podcast/id1490521721?i=1000700104349';

  function init() {
    var triggers = document.querySelectorAll('[data-apple-podcast-modal]');
    var modal = document.getElementById('SeilerApplePodcastModal');
    var dismissers = modal ? modal.querySelectorAll('[data-seiler-podcast-dismiss]') : [];
    var firstFocus = modal && modal.querySelector('[data-seiler-podcast-first-focus]');
    var iframe = document.getElementById('SeilerApplePodcastIframe');
    var activeTrigger = null;

    if (!triggers.length || !modal || !iframe) return;

    function openModal(trigger) {
      activeTrigger = trigger;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      iframe.src = EMBED_SRC;
      if (firstFocus) {
        window.requestAnimationFrame(function () {
          firstFocus.focus();
        });
      }
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      iframe.removeAttribute('src');
      if (activeTrigger) activeTrigger.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(trigger);
      });
    });

    dismissers.forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
